import React from 'react';
import { compose } from 'recompose';
import { HTMLTrans, TransLink } from '../Common/Translations';
import config from '../../config';
import { withStoreDetail } from '../Common/Providers/WithStoreDetail';
import { willHideOnMuslimPro } from '../Common/Store/Store';
import ScrollableTab from '../Common/ScrollableTab';

const Card = (props) => {
  const {
    currency,
    product = {},
  } = props;
  return (
    <div className="card h-100">
      <div className="p-3">
        {product.img &&
        <TransLink url={product.url}>
          <img className="img-fluid lazyload" data-src={config.s3BucketUrl+product.img} width="261" height="261" alt={product.name}/>
        </TransLink>}
      </div>
      <div className="px-3 pb-3">
        <h5 className="ProximaNova-Bold mb-2">{product.name}</h5>
        <div className="small text-gray">
          {product.priceBefore &&
          <div>From <del>{currency} {product.priceBefore}</del></div>}
          {product.priceAfter &&
          <strong className="ProximaNova-Bold text-secondary">{currency} {product.priceAfter}</strong>}
        </div>
      </div>
    </div>
  );
};

const TabbedSection = (props) => {
  const {
    index,
    id,
    productData = '',
    currency,
  } = props.data;
  const products = productData ? productData.split('\n') : [];
  const strFirst = index === 0 ? 'show active' : '';
  return (
    <div className={`tab-pane fade ${strFirst}`} id={id} role="tabpanel">
      <div className="row px-2 justify-content-center">
        {products.map((value, index) => {
          const product = { name: '', img: '', url: '', priceBefore: '', priceAfter: '' };
          const productDetails = value.split('|');
          productDetails.forEach((elem, i) => {
            product[Object.keys(product)[i]] = elem;
          });
          if (product.name || product.img) {
            return (
              <div key={`tabpane-col-${index}`} className="col-6 col-lg-3 px-1 px-sm-2 mb-2 mb-sm-3">
                <Card product={product} currency={currency} />
              </div>
            );
          }
          return '';
        })}
      </div>
    </div>
  );
};

const TopPicksOfTheMonth = (props) => {
  const {
    store,
    t,
  } = props;
  const menus = {
    bestSeller: `${t('landing_page.toppicksofthemonth-tab1', 'Bestsellers')}`,
    trendingProduct: `${t('landing_page.toppicksofthemonth-tab2', 'Trending Products')}`,
    featuredGift: `${t('landing_page.toppicksofthemonth-tab3', 'Featured Gifts')}`,
  };
  const productBySection = {
    bestSeller: `${t('landing_page.toppicksofthemonth-bestSeller', '\n\n\n')}`,
    trendingProduct: `${t('landing_page.toppicksofthemonth-trendingProduct', '\n\n\n')}`,
    featuredGift: `${t('landing_page.toppicksofthemonth-featuredGift', '\n\n\n')}`,
  };
  const name = store.name || 'Photobook';
  return (
    <div id="toppick" className="py-5 bg-primary-lighten-2 content-visibility-auto"
         style={{ backgroundColor: `${t('landing_page.toppicksofthemonth_background_color', '')}`}}>
      <div className="container">
        <div className="row my-2">
          <div className="col-12 text-center">
            <h2 className="ProximaNova-Bold landing-h4 mb-2"><HTMLTrans id="landing_page.toppicksofthemonth_title" variables={{ 'name': name }}>{name}'s Top Picks of the Month</HTMLTrans></h2>
          </div>
        </div>
        <div className="row my-2">
          <div className="col-12 mb-3">
            <ScrollableTab menus={menus} linkColor={`${t('landing_page.toppicksofthemonth_tab_color', '')}`}/>
          </div>
          <div className="col-12">
            <div className="tab-content text-center">
              {Object.keys(productBySection).map((key, index) => (
                <TabbedSection key={`tabpanel-${index}`} data={{
                  index,
                  id: key,
                  productData: productBySection[key],
                  currency: store.currency.code
                }}/>
              ))}
            </div>
          </div>
        </div>
        <div className="text-center my-2">
            <small><TransLink url='/product'>{t('landing_page.toppicksofthemonth_link_text', 'View all products >')}</TransLink></small>
        </div>
      </div>
    </div>
  );
};

const enhance = compose(
  withStoreDetail,
  willHideOnMuslimPro,
);
export default enhance(TopPicksOfTheMonth);
export const undecorated = TopPicksOfTheMonth;



// WEBPACK FOOTER //
// ./src/LandingPage/TopPicksOfTheMonth.js